import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export const tabTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      // Legacy properties (for backward compatibility)
      backgroundColor: theme.color.surface[2],
      textColor: theme.color.text.core['-secondary'],
      tabContainerBG: theme.color.surface[2],
      tabSelectedText: theme.color.text.core['-primary'],
      // TabItemV3 properties
      activeBackgroundColor: theme.color.surface[1],
      activeBorderColor: theme.color.focus[3],
      inactiveBorderColor: theme.color.surface[4], // Surface-Neutral-4
      hoverBackgroundColor: theme.color.surface[1],
      modeTextColor: theme.color.text.core['-tertiary'],
      dirtyIndicatorColor: theme.color.dataVis.core['critical-1'],
      dropdownHoverColor: theme.color.surface[2],
      // TabContainerV3 properties
      containerBackgroundColor: theme.color.surface[2],
      borderColor: theme.color.surface[3],
      buttonHoverColor: theme.color.surface[1],
      emptyStateTextColor: theme.color.text.core['-tertiary'],
      emptyStateBackgroundColor: theme.color.surface[2],
      emptyStateTitleColor: theme.color.text.core['-primary'],
      emptyStateLogo: key === 'light' ? '/controlrooms_dark.png' : '/controlrooms-light.png',
    },
  ]),
);
